import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { HistoricoPesquisasMensalService } from 'src/app/services/historicoPesquisasMensal.service';
import { LogPesquisaService } from 'src/app/services/log-pesquisa.service';

@Component({
    selector: 'app-pesquisa',
    templateUrl: './pesquisa.component.html',
    styleUrls: ['./pesquisa.component.css'],
    standalone: false
})
export class PesquisaComponent implements OnInit {
  //Mais pesquisadas
  MPtotal = 0;
  MPloading = true;
  MPpageSize = 10;
  MPpageIndex = 1;
  maisPesquisadas = [];
  dataInicial: any;
  dataFinal: any;

  //Pequisas de Hoje
  PHtotal = 0;
  PHloading = true;
  PHpageSize = 10;
  PHpageIndex = 1;
  pesquisasHoje = [];

  //Indicadores
  dataAtual = new Date();
  loadingQtdPesquisas = true;
  qtdPesquisas = 0;
  qtdPesquisasMes = 0;
  isVisibleHistorico = false;
  
  constructor(
    private logPesquisaService: LogPesquisaService,
    private historicoPesquisasMensalService: HistoricoPesquisasMensalService
  ) { }

  ngOnInit(): void {
    this.logPesquisaService.qtdPesquisaData().subscribe((l: any) => {
      this.qtdPesquisas = l.data.log_pesquisa;
      this.loadingQtdPesquisas = false;
    });

    this.historicoPesquisasMensalService.mesAtual().subscribe((data: any) => {
      this.qtdPesquisasMes = data.data.historico;
    });

  }

  openHistoricoPesquisasMensal(){
    this.isVisibleHistorico = true;
  }

  closeHistorico(){
    this.isVisibleHistorico = false;
  }

  onQueryParamsChangeMP(params: NzTableQueryParams): void {
    this.getMaisPesquisadas();
  }

  getMaisPesquisadas(){
    this.MPloading = true;
    this.logPesquisaService.maisPesquisadas(this.dataInicial, this.dataFinal).subscribe((m: any) => {
      this.maisPesquisadas = m.data.log_pesquisa.data;
      this.dataInicial = m.data.dataInicial;
      this.dataFinal = m.data.dataFinal;
      this.MPloading = false;
    });
  }

  onQueryParamsChangePH(params: NzTableQueryParams): void {
    this.PHloading = true;
    this.logPesquisaService.pesquisaPorData().subscribe((m: any) => {
      this.pesquisasHoje = m.data.log_pesquisa.data;
      this.PHloading = false;
    });
  }

}
